import React, {useState, useEffect} from "react";
import axios from "axios";

//requestSectionContent will request the full content from shopif and parse out the main area to allow the page to be customized by the theme templates

export default ({handle, requestSectionContent = false}) => {

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState();

  useEffect(() => {
    getPage();
  }, [handle])

  const getPage = async () => {
    setLoading(true);
    if(!requestSectionContent){
      const response = await axios.get(`/pages/${handle}.json`);
      setPage(response.data?.page);
      setLoading(false);
    } else {
      const response = await axios.get(`/pages/${handle}`);
      const doc = new DOMParser().parseFromString(response.data, 'text/html');
      const main = doc.querySelector('[role="main"]');
      const body_html = main?.innerHTML.split('<!-- END_MAIN_CONTENT -->')[0] ?? '';
      setPage({ body_html });
      setLoading(false);
    }
  }

  function createMarkup() { return {__html: page?.body_html}; };

  return <div>
      {!loading && page ?
        <div dangerouslySetInnerHTML={createMarkup()} />
        :
        <pill-loader class="pill-loader" aria-busy={true}></pill-loader>
      }
    </div>;
}
